export default "__VITE_ASSET__aUzZDUJF__"